import CityPageTemplate from "../city-template/CityPageTemplate";
import { twinFallsConfig } from "./data";

export default function TwinFallsPage() {
  return <CityPageTemplate config={twinFallsConfig} />;
}